import type { PaginationMetadata } from "./common";

export const USER_ACCOUNT_STATUSES = ["active", "inactive"] as const;

export type UserAccountStatus = (typeof USER_ACCOUNT_STATUSES)[number];

export interface UserAccount {
  id: string;
  // Home/default workspace — every user has one, including
  // canSwitchWorkspace roles (Developer/Franchisor).
  workspaceId: string;
  roleIds: string[];
  name: string;
  email: string;
  phone: string;
  countryCode: string;
  status: UserAccountStatus;
  isProtected: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateUserAccountReq {
  name: string;
  email: string;
  password: string;
  phone: string;
  country_code: string;
  role_ids: string[];
  // Optional on input — defaults to the main workspace if omitted.
  workspace_id?: string;
}

export interface UpdateUserAccountReq {
  name?: string;
  email?: string;
  phone?: string;
  country_code?: string;
  role_ids?: string[];
  status?: UserAccountStatus;
  workspace_id?: string;
}

export interface GetUserAccountReq {
  q?: string;
}

export interface UserAccountList {
  items: UserAccount[];
  pagination: PaginationMetadata;
}
